import { useEffect, useId } from 'react';

export type UseLifecycleDebug = (title: string, props: Record<string, any>) => void;

export const useLifecycleDebug: UseLifecycleDebug = (title, props) => {
  const id = useId().slice(2, -1);
  const entries = Object.entries(props ?? {});

  entries.forEach(([key, value]) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (!title || !entries?.length) return;

      const mountStyles = 'background-color: green; padding: 3px 10px';
      console.group(`%c#${id} > ${title} > ${key}`, mountStyles);
      console.debug(value);
      console.groupEnd();

      return () => {
        const unmountStyles = 'background-color: indianred; padding: 3px 10px';
        console.group(`%c#${id} > ${title} > ${key}`, unmountStyles);
        console.debug(value);
        console.groupEnd();
      };
    }, [key, value]);
  });
};
